"use strict";

document.querySelector('.header__navtoggler').addEventListener('click', () => {
 document.body.classList.toggle('body--activenav');
});

/* Draw SVG for timeline-Sections */

let drawSVG = (element) => {
  // Get currentfontSize for rem immitation in coordinates
  var fontSizeFloat = window.getComputedStyle(document.getElementsByTagName("html")[0], null).getPropertyValue('font-size');
  var fontSize = parseFloat(fontSizeFloat);

  // Create SVG
  let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute('style', 'fill:none; stroke:#2FAE7A; stroke-width:2px; stroke-dasharray:8px,8px; position: absolute; z-index: -1; top: 0; left: 0; stroke-linejoin: round; border-radius: 25px');
  svg.setAttribute('width', '100vw');
  svg.setAttribute('height', 'calc(20rem + ' + element.clientHeight + 'px)');
  svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");

  // Create Path

  console.log((window.innerWidth - element.querySelectorAll('.featurecard--box')[2].getBoundingClientRect().right) / 2);

  let box1position = element.querySelectorAll('.featurecard--box')[0].getBoundingClientRect();
  let box3position = element.querySelectorAll('.featurecard--box')[2].getBoundingClientRect();

  let points = [
    [0, 0],
    [box1position.left / 2, 0], //p2 -> Abstand zum ersten Kasten vom linken Bildschirmrand / 2
    [box1position.left / 2, element.querySelectorAll('.featurecard--box')[0].clientHeight / 2 + 6 * fontSize],
    [box3position.left + element.querySelectorAll('.featurecard--box')[2].clientWidth + (window.innerWidth - box3position.right) / 2 , box1position.left / 2],
    [box3position.left + element.querySelectorAll('.featurecard--box')[2].clientWidth + (window.innerWidth - box3position.right) / 2 , element.querySelectorAll('.featurecard--box')[2].offsetTop + element.querySelectorAll('.featurecard--box')[2].clientHeight / 2 + 6 * fontSize],
    [box1position.left / 2 + 4 * fontSize, element.querySelectorAll('.featurecard--box')[2].offsetTop + element.querySelectorAll('.featurecard--box')[2].clientHeight / 2 + 6 * fontSize],
    [box1position.left / 2 + 4 * fontSize, element.querySelectorAll('.featurecard--box')[2].offsetTop + element.querySelectorAll('.featurecard--box')[2].clientHeight + 12 * fontSize],
    [window.innerWidth / 2, element.querySelectorAll('.featurecard--box')[2].offsetTop + element.querySelectorAll('.featurecard--box')[2].clientHeight + 12 * fontSize],
    [window.innerWidth / 2, element.querySelectorAll('.featurecard--box')[2].offsetTop + element.querySelectorAll('.featurecard--box')[2].clientHeight + 20 * fontSize]
  ];

  let path = document.createElementNS("http://www.w3.org/2000/svg", 'path'); // Create Path-Element
  path.setAttribute('d', 'M0 0 H ' + points[1][0] + ' V ' + points[2][1] + ' H ' + points[3][0] + ' V ' + points[4][1] + ' H ' + points[5][0] + ' V ' + points[6][1] + ' H ' + points[7][0] + ' V ' + points[8][1]);

  let circle = document.createElementNS("http://www.w3.org/2000/svg", 'circle'); // Create Circle-Element
  circle.setAttribute('fill', '#27AD7A');
  circle.setAttribute('stroke-width', '0px');
  circle.setAttribute('cx', points[8][0]);
  circle.setAttribute('cy', points[8][1]);
  circle.setAttribute('r', '15');

  svg.appendChild(path); // Append Path to SVG
  svg.appendChild(circle);
  element.appendChild(svg); // Append SVG To Element
}
let timelines = document.querySelectorAll('.timeline');

let appendSVG = () =>  {
  if (timelines.length > 0) {
    for (let timeline of timelines) {
     if(timeline.getElementsByTagName('svg').length > 0) {
      timeline.removeChild(timeline.querySelector('svg'));
     }
     if(window.innerWidth > 991) {
       drawSVG(timeline);
       console.log('SVG drawn');
     }
     return
    }
  }
}

// window.addEventListener('DOMContentLoaded', appendSVG);

window.onload = () => {
 appendSVG();
}

window.addEventListener('resize', appendSVG);
